import { render, staticRenderFns } from "./PendingGroupRegistrationList.vue?vue&type=template&id=4c12e0ed&"
import script from "./PendingGroupRegistrationList.vue?vue&type=script&lang=js&"
export * from "./PendingGroupRegistrationList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports